module.exports = __webpack_public_path__ + "img/de-logo-white_no_line.4d5b0848.png";